import { render, staticRenderFns } from "./FeedbackAssignDialog.vue?vue&type=template&id=35012546&scoped=true"
import script from "./FeedbackAssignDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackAssignDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackAssignDialog.vue?vue&type=style&index=0&id=35012546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35012546",
  null
  
)

export default component.exports